import { Button, Dialog, Flex, Text } from "@radix-ui/themes";

export interface RollPositionDialogPresentationProps {
  open: boolean;
  contractLabel: string;
  quantity: string;
  currentPrice: string;
  onOpenChange: (open: boolean) => void;
  onConfirmRoll: () => void;
}

export const RollPositionDialogPresentation = ({
  open,
  contractLabel,
  quantity,
  currentPrice,
  onOpenChange,
  onConfirmRoll,
}: RollPositionDialogPresentationProps) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Content maxWidth="28rem">
      <Dialog.Title>Roll position</Dialog.Title>
      <Dialog.Description size="2" mb="3" color="gray">
        Prepare a closing order ticket for this contract. Review and submit from
        the ticket — nothing is sent yet.
      </Dialog.Description>
      {open ? (
        <Flex direction="column" gap="1" mb="4">
          <Text size="2" weight="medium">
            {contractLabel}
          </Text>
          <Text size="1" color="gray" className="atd-numeric">
            Qty {quantity} · Mark {currentPrice}
          </Text>
        </Flex>
      ) : null}
      <Flex gap="2" justify="end">
        <Dialog.Close>
          <Button type="button" variant="soft" color="gray">
            Cancel
          </Button>
        </Dialog.Close>
        <Button type="button" variant="solid" onClick={onConfirmRoll}>
          Roll
        </Button>
      </Flex>
    </Dialog.Content>
  </Dialog.Root>
);
